import { gql } from '@apollo/client'
import ITEMS_PER_PAGE from '@utils/constants'

const GET_APPLICATIONS = gql`
  query GetApplications($filters: JSON) {
    applications(filters: $filters) {
      collection {
        id
        name
        createdAt
        updatedAt
      }
      metadata {
        totalCount
        currentPage
        limitValue
      }
    }
  }
`

export default GET_APPLICATIONS
